/**
 * Shared world-to-model loading. The IDE and the lesson thumbnails both need
 * to turn a bundled world name into a `KarelModel`; centralizing it keeps the
 * parsing and error handling consistent.
 */
import type { CanvasModel } from "../core/canvasModel";
import { KarelModel, type KarelModelShape } from "../core/karelModel";
import { requireWorldText } from "./assets";

/**
 * Parses a bundled world into a model using the supplied canvas geometry. The
 * caller owns the `CanvasModel` because the IDE resizes it in place while
 * thumbnails render at a fixed size.
 */
export function loadWorldModel(
  name: string,
  canvasModel: CanvasModel,
): KarelModelShape {
  const model = KarelModel();
  model.loadWorld(requireWorldText(name), canvasModel);
  return model;
}
